// @flow

export default {
  // comments and discussions
  openFlagModal(state: State, id: number) {
    state.flagModal = { active: true, id }
  },
  closeFlagModal(state: State) {
    state.flagModal = { active: false, id: -1 }
  },

  // this is just for comments
  openDeleteConfirmationModal(state: State, id: number) {
    state.deleteConfirmationModal = { active: true, id }
  },

  closeDeleteConfirmationModal(state: State) {
    state.deleteConfirmationModal = { active: false, id: -1 }
  },

  updateUser(state: State, newUser: $Shape<User>) {
    state.user = {
      ...state.user,
      ...newUser,
    }
  },

  updateSettings(state: State, newSettings: $Shape<UserSettings>) {
    state.settings = {
      ...state.settings,
      ...newSettings,
    }
  },

  updateConsents(state: State, newConsents: $Shape<UserConsents>) {
    state.consents = {
      ...state.consents,
      ...newConsents,
    }
  },

  setDiscussion(state: State, discussion: $Shape<DiscussionLike>) {
    state.discussion = {
      ...state.discussion,
      ...discussion,
    }
  },

  // currently these toggles are just discussions and use the state article object.
  // Comments use toggleCommentLik
  setLike(state: State, isLiked: boolean) {
    state.discussion.isLiked = isLiked
  },
  increaseLikeCount(state: State) {
    state.discussion.likeCount++
  },
  decreaseLikeCount(state: State) {
    state.discussion.likeCount--
  },

  setUserLoggedOut(state: State) {
    state.user = {
      isLoggedIn: false,
      displayName: 'Guest',
      firstName: 'guest',
      username: 'guest',
      avatar: '',
      notificationCount: 0,
      startMonday: 0,
    }
  },

  setErrorModalIsActive(state: State, isActive: boolean) {
    state.errorModal.active = isActive
  },

  setLoginModalIsActive(state: State, isActive: boolean) {
    state.loginModal.active = isActive
  },

  setRefreshScheduledInstances(state: State, refresh: boolean) {
    state.refreshScheduledInstances = refresh
  },
}
